export default __webpack_public_path__ + "static/media/Path3419.1a634c21.svg";